import React from 'react'
import './tabs.css'

export default class Tabs extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tabId: 0
        }
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(e, tabId) {
        e.preventDefault()
        this.setState({
            tabId
        })
    }

    render() {

        let childCount = 0

        return(
            <React.Fragment>
                {
                    this.props.tabs.map((tab, i) => <a href='#tab' className={`tab__link${ i === this.state.tabId ? ' tab__link--selected' : '' }`} key={i} onClick={ (e) => { this.handleClick(e, i) } }>{ tab }</a>)
                }
                {
                    React.Children.map(this.props.children, child => {
                        const hidden = this.state.tabId === childCount ? '' : ' tab--hidden'
                        childCount++
                        return <div key={childCount} className={`tab${ hidden }`}>{ child }</div>
                    })
                }
            </React.Fragment>
        )

    }

}


// WEBPACK FOOTER //
// ./src/components/Tabs/index.js